import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const resultadoInterposicaoRecursoProfissionalRoutes: Routes = [
  {
    path: 'resultado-interposicao-recurso-profissional',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./resultado-interposicao-recurso-profissional.component').then(
            (m) => m.ResultadoInterposicaoRecursoProfissionalComponent,
          ),
        data: {
          title: 'Gerar Resultado Interposição de Recurso Profissional',
          roles: [Role.RESULTADO_RECURSO_PROFISSIONAL_CONSULTAR],
          breadcrumb: [
            { label: 'Gerar Resultado Interposição de Recurso Profissional', url: '/resultado-interposicao-recurso-profissional' },
          ],
        },
      },
    ],
  },
];
